import React from 'react';
import { FormattedMessage } from 'react-intl';

const getPropertyLabel = (prop: string) => {
    const propertyLabels = {
        'serialNumber': 'intl-msg:serialNumber',
        'inCustomerFleet': 'intl-msg:inCustomerFleet',
        'updatesActive': 'intl-msg:blocked',
        'updateBlockedReason': 'intl-msg:blockedReason',
        'testReleasesActive': 'intl-msg:testReleasesActive',
        'replaced': 'intl-msg:replaced',
        'productionMode': 'intl-msg:deviceProdMode',
        'description': 'intl-msg:description',
        'deviceGroups': 'intl-msg:groups',
        'type': 'intl-msg:deviceType',
        'vin': 'intl-msg:VIN'
    };

    return propertyLabels[prop] ? <FormattedMessage id={propertyLabels[prop]} /> : <FormattedMessage id={`intl-msg:${prop}`} defaultMessage={prop} />;
};

export const deviceHistoryColumnDescriptors = [
    {
        id: 'changeTimestamp',
        field: 'changeTimestamp',
        label: 'intl-msg:timestamp',
        className: 'width-20pct',
        format: (val: number) => new Date(val).toLocaleString()
    },
    {
        id: 'propertyChanges',
        field: 'propertyChanges',
        label: 'intl-msg:changes',
        className: 'width-50pct',
        format: (changes: Record<string, any>) => {
            return (
                <div className="margin-bottom-10">
                    {Object.entries(changes).map(([prop, change]: [string, any], index) => {
                        let oldValue = change.oldValue !== null && change.oldValue !== undefined && change.oldValue !== '' ? String(change.oldValue) : '-';
                        let newValue = change.newValue !== null && change.newValue !== undefined && change.newValue !== '' ? String(change.newValue) : '-';

                        //special condition where the FE lable (blocked) means the oposite than the bd field (updatesActive)
                        if (prop === 'updatesActive' && oldValue !== '-') oldValue = String(!JSON.parse(oldValue));
                        if (prop === 'updatesActive' && newValue !== '-') newValue = String(!JSON.parse(newValue));

                        return (
                            <div key={prop} className="margin-bottom-5">
                                <label className="text-bold">{getPropertyLabel(prop)}:</label>
                                <span className="margin-left-10">
                                    <span className="text-decoration-line-through">{oldValue}</span>
                                    <span className="margin-left-5 margin-right-5">→</span>
                                    <span className={'text-color-success'}>{newValue}</span>
                                </span>
                            </div>
                        );

                    })}
                </div>
            );
        },
    },
    {
        id: 'changedBy',
        field: 'changedBy',
        label: 'intl-msg:changedBy',
        className: 'width-30pct'
    }
];
